import React from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { schemas } from '@recurrency/core-api-schema';
import { TenantUserPermission } from '@recurrency/core-api-schema/dist/common/enums';

import { Button } from 'components/Button';
import { SmallLoader } from 'components/Loaders';

import { useCoreApi } from 'hooks/useApi';
import { useGlobalApp } from 'hooks/useGlobalApp';

import { showAsyncModal } from 'utils/asyncModal';

import { DownloadNgrokAgentModal } from './DownloadNgrokAgentModal';

export function DownloadNgrokAgentButton() {
  const { activeTenant } = useGlobalApp();
  const {
    data: agents,
    isLoading,
    error,
  } = useCoreApi(schemas.integrations.getAllAgentsByTenant, {
    pathParams: { tenantId: activeTenant.id },
  });

  function openIntercomModal() {
    if (window.Intercom) {
      window.Intercom('show');
    }
  }

  if (isLoading) {
    return <SmallLoader />;
  }
  if (error || !agents || agents.items.length === 0) {
    return (
      <>
        Error preparing your agent automatically, please contact your Solutions Engineer.
        <Button type="link" size="small" onClick={openIntercomModal}>
          Don't have a Solutions Engineer? Reach out to us here.
        </Button>
      </>
    );
  }
  return (
    <Button
      type="primary"
      permissionsRequired={[TenantUserPermission.ActionEditSettings]}
      onClick={() =>
        showAsyncModal(DownloadNgrokAgentModal, {
          agent: agents.items[0],
          tenant: activeTenant,
        })
      }
    >
      <DownloadOutlined /> Configure Agent
    </Button>
  );
}
